@if (state() === 'LOCKED') {
  <!-- a lock alone, as big for every label, so locked places don't stand out by their names -->
  <div
    class="shadow-raised grid size-16 place-items-center rounded-xl border border-slate-500 bg-linear-to-b from-slate-600 to-slate-700 text-3xl text-slate-300 shadow-slate-900 inset-shadow-white/15"
    [class.anim-burst-in]="changedFrom() === 'MYSTERY'"
    [class.wait-100]="changedFrom() === 'MYSTERY'"
  >
    <fa-icon [icon]="faLock" />
  </div>
} @else if (state() === 'MYSTERY') {
  <!-- as big as a lock, so the names don't show through their lengths either. Once it's decided it shrinks away while what it turns out to be (the name or a lock) bursts out of the same spot, so it reads as the question mark growing into it -->
  <div
    animate.leave="anim-pop-out"
    class="shadow-raised grid size-16 place-items-center rounded-xl border border-white/80 bg-linear-to-b from-white to-slate-100 text-3xl text-slate-500 shadow-slate-300 inset-shadow-white"
  >
    <fa-icon [icon]="faQuestion" />
  </div>
} @else if (state() === 'FINISHED') {
  <!-- every part is visited, but some may still have assignments left -->
  <div
    class="shadow-raised relative flex flex-col items-center gap-1 rounded-xl border border-green-400 bg-linear-to-b from-green-500 to-green-600 px-2.5 py-1 shadow-green-800 inset-shadow-white/40"
  >
    @if (pulsing()) {
      <span class="anim-pulse-ring pointer-events-none absolute -inset-px rounded-xl outline-4 outline-amber-400"></span>
    }
    <p class="font-default text-lg font-semibold text-white text-shadow-2xs text-shadow-black/20">{{ name() }}</p>
    <div class="flex gap-1.5">
      @for (dot of dots(); track $index) {
        <rid-progress-dot class="size-3" [progress]="dot" tone="GREEN" />
      }
    </div>
  </div>
} @else {
  <div
    class="shadow-raised relative flex flex-col items-center gap-1.5 rounded-xl border border-white/80 bg-linear-to-b from-white to-slate-100 px-3 py-1.5 shadow-slate-300 inset-shadow-white"
    [class.anim-burst-in]="changedFrom() === 'MYSTERY'"
    [class.wait-100]="changedFrom() === 'MYSTERY'"
  >
    @if (pulsing()) {
      <span class="anim-pulse-ring pointer-events-none absolute -inset-px rounded-xl outline-4 outline-amber-400"></span>
    }
    <p class="font-default text-2xl font-semibold text-slate-700 text-shadow-2xs text-shadow-white">{{ name() }}</p>
    <div class="flex gap-1.5">
      @for (dot of dots(); track $index) {
        <rid-progress-dot class="size-3" [progress]="dot" />
      }
    </div>
  </div>
}
